import React, { useMemo, useCallback } from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function JsonFormatter(_ref) {
  var json = _ref.json,
      _ref$tabWith = _ref.tabWith,
      tabWith = _ref$tabWith === void 0 ? 2 : _ref$tabWith,
      _ref$jsonStyle = _ref.jsonStyle;
  _ref$jsonStyle = _ref$jsonStyle === void 0 ? {} : _ref$jsonStyle;
  var _ref$jsonStyle$boolea = _ref$jsonStyle.booleanStyle,
      booleanStyle = _ref$jsonStyle$boolea === void 0 ? {} : _ref$jsonStyle$boolea,
      _ref$jsonStyle$braceS = _ref$jsonStyle.braceStyle,
      braceStyle = _ref$jsonStyle$braceS === void 0 ? {} : _ref$jsonStyle$braceS,
      _ref$jsonStyle$bracke = _ref$jsonStyle.bracketStyle,
      bracketStyle = _ref$jsonStyle$bracke === void 0 ? {} : _ref$jsonStyle$bracke,
      _ref$jsonStyle$commaS = _ref$jsonStyle.commaStyle,
      commaStyle = _ref$jsonStyle$commaS === void 0 ? {} : _ref$jsonStyle$commaS,
      _ref$jsonStyle$falseS = _ref$jsonStyle.falseStyle,
      falseStyle = _ref$jsonStyle$falseS === void 0 ? {} : _ref$jsonStyle$falseS,
      _ref$jsonStyle$nullSt = _ref$jsonStyle.nullStyle,
      nullStyle = _ref$jsonStyle$nullSt === void 0 ? {} : _ref$jsonStyle$nullSt,
      _ref$jsonStyle$number = _ref$jsonStyle.numberStyle,
      numberStyle = _ref$jsonStyle$number === void 0 ? {} : _ref$jsonStyle$number,
      _ref$jsonStyle$proper = _ref$jsonStyle.propertyStyle,
      propertyStyle = _ref$jsonStyle$proper === void 0 ? {} : _ref$jsonStyle$proper,
      _ref$jsonStyle$string = _ref$jsonStyle.stringStyle,
      stringStyle = _ref$jsonStyle$string === void 0 ? {} : _ref$jsonStyle$string,
      _ref$jsonStyle$style = _ref$jsonStyle.style,
      style = _ref$jsonStyle$style === void 0 ? {} : _ref$jsonStyle$style,
      _ref$jsonStyle$tabSpa = _ref$jsonStyle.tabSpaceStyle,
      tabSpaceStyle = _ref$jsonStyle$tabSpa === void 0 ? {} : _ref$jsonStyle$tabSpa,
      _ref$jsonStyle$trueSt = _ref$jsonStyle.trueStyle,
      trueStyle = _ref$jsonStyle$trueSt === void 0 ? {} : _ref$jsonStyle$trueSt,
      _ref$jsonClassName = _ref.jsonClassName;
  _ref$jsonClassName = _ref$jsonClassName === void 0 ? {} : _ref$jsonClassName;
  var _ref$jsonClassName$bo = _ref$jsonClassName.booleanClassName,
      booleanClassName = _ref$jsonClassName$bo === void 0 ? '' : _ref$jsonClassName$bo,
      _ref$jsonClassName$br = _ref$jsonClassName.braceClassName,
      braceClassName = _ref$jsonClassName$br === void 0 ? '' : _ref$jsonClassName$br,
      _ref$jsonClassName$br2 = _ref$jsonClassName.bracketClassName,
      bracketClassName = _ref$jsonClassName$br2 === void 0 ? '' : _ref$jsonClassName$br2,
      _ref$jsonClassName$cl = _ref$jsonClassName.className,
      className = _ref$jsonClassName$cl === void 0 ? '' : _ref$jsonClassName$cl,
      _ref$jsonClassName$co = _ref$jsonClassName.commaClassName,
      commaClassName = _ref$jsonClassName$co === void 0 ? '' : _ref$jsonClassName$co,
      _ref$jsonClassName$fa = _ref$jsonClassName.falseClassName,
      falseClassName = _ref$jsonClassName$fa === void 0 ? '' : _ref$jsonClassName$fa,
      _ref$jsonClassName$nu = _ref$jsonClassName.nullClassName,
      nullClassName = _ref$jsonClassName$nu === void 0 ? '' : _ref$jsonClassName$nu,
      _ref$jsonClassName$nu2 = _ref$jsonClassName.numberClassName,
      numberClassName = _ref$jsonClassName$nu2 === void 0 ? '' : _ref$jsonClassName$nu2,
      _ref$jsonClassName$pr = _ref$jsonClassName.propertyClassName,
      propertyClassName = _ref$jsonClassName$pr === void 0 ? '' : _ref$jsonClassName$pr,
      _ref$jsonClassName$st = _ref$jsonClassName.stringClassName,
      stringClassName = _ref$jsonClassName$st === void 0 ? '' : _ref$jsonClassName$st,
      _ref$jsonClassName$ta = _ref$jsonClassName.tabSpaceClassName,
      tabSpaceClassName = _ref$jsonClassName$ta === void 0 ? '' : _ref$jsonClassName$ta,
      _ref$jsonClassName$tr = _ref$jsonClassName.trueClassName,
      trueClassName = _ref$jsonClassName$tr === void 0 ? '' : _ref$jsonClassName$tr;
  var jsonObject = useMemo(function () {
    return JSON.parse(json);
  }, [json]);
  var repeatTabSpace = useCallback(function (times) {
    var repeatedTabSpace = [];

    for (var i = 0; i < times; i++) {
      repeatedTabSpace.push(React.createElement("span", {
        className: tabSpaceClassName,
        key: i,
        style: tabSpaceStyle
      }, '\xa0'.repeat(tabWith || 4)));
    }

    return repeatedTabSpace;
  }, [tabSpaceClassName, tabSpaceStyle, tabWith]);
  var categorize = useCallback(function (data) {
    var TabSpaceRepeatTimes = 0;

    switch (Object.prototype.toString.call(data)) {
      case '[object Number]':
        {
          var dataJSX = React.createElement("span", {
            className: numberClassName,
            style: numberStyle
          }, data);
          return dataJSX;
        }

      case '[object String]':
        {
          var _dataJSX = React.createElement("span", {
            className: stringClassName,
            style: stringStyle
          }, "\"" + data + "\"");

          return _dataJSX;
        }

      case '[object Boolean]':
        {
          var _dataJSX2 = data ? React.createElement("span", {
            className: booleanClassName + " " + trueClassName,
            style: _extends({}, booleanStyle, trueStyle)
          }, "true") : React.createElement("span", {
            className: booleanClassName + " " + falseClassName,
            style: _extends({}, booleanStyle, falseStyle)
          }, "false");

          return _dataJSX2;
        }

      case '[object Object]':
        {
          var _dataJSX3 = [];

          _dataJSX3.push(React.createElement(React.Fragment, {
            key: '{'
          }, React.createElement("span", {
            className: braceClassName,
            style: braceStyle
          }, '{'), React.createElement("br", null)));

          var keys = Object.keys(data);
          TabSpaceRepeatTimes += 1;
          Object.keys(data).forEach(function (key, index) {
            _dataJSX3.push(React.createElement(React.Fragment, {
              key: index
            }, repeatTabSpace(TabSpaceRepeatTimes), React.createElement("span", {
              className: propertyClassName,
              style: propertyStyle
            }, "\"" + key + "\": "), categorize(data[key]), index !== keys.length - 1 && React.createElement("span", null, ","), React.createElement("br", null)));
          });
          TabSpaceRepeatTimes -= 1;

          _dataJSX3.push(React.createElement(React.Fragment, {
            key: '}'
          }, repeatTabSpace(TabSpaceRepeatTimes), React.createElement("span", {
            className: braceClassName,
            style: braceStyle
          }, '}')));

          return _dataJSX3;
        }

      case '[object Array]':
        {
          var _dataJSX4 = [];

          _dataJSX4.push(React.createElement(React.Fragment, {
            key: '['
          }, React.createElement("span", {
            className: bracketClassName,
            style: bracketStyle
          }, "["), React.createElement("br", null)));

          TabSpaceRepeatTimes += 1;

          for (var i = 0; i < data.length; i++) {
            _dataJSX4.push(React.createElement(React.Fragment, {
              key: i
            }, repeatTabSpace(TabSpaceRepeatTimes), categorize(data[i]), i === data.length - 1 ? null : React.createElement("span", {
              className: commaClassName,
              style: commaStyle
            }, ","), React.createElement("br", null)));
          }

          TabSpaceRepeatTimes -= 1;

          _dataJSX4.push(React.createElement(React.Fragment, {
            key: ']'
          }, repeatTabSpace(TabSpaceRepeatTimes), React.createElement("span", {
            className: bracketClassName,
            style: bracketStyle
          }, "]")));

          return _dataJSX4;
        }

      case '[object Null]':
        {
          var _dataJSX5 = React.createElement("span", {
            className: nullClassName,
            style: nullStyle
          }, "null");

          return _dataJSX5;
        }

      default:
        return React.createElement("span", null, "type error");
    }
  }, [booleanClassName, booleanStyle, braceClassName, braceStyle, bracketClassName, bracketStyle, commaClassName, commaStyle, falseClassName, falseStyle, nullClassName, nullStyle, numberClassName, numberStyle, propertyClassName, propertyStyle, repeatTabSpace, stringClassName, stringStyle, trueClassName, trueStyle]);
  var result = useMemo(function () {
    return categorize(jsonObject);
  }, [categorize, jsonObject]);
  return React.createElement("div", {
    className: className,
    style: style
  }, React.createElement("div", null, result));
}

export default JsonFormatter;